import { render, staticRenderFns } from "./job.vue?vue&type=template&id=183852ac&scoped=true"
import script from "./job.vue?vue&type=script&lang=js"
export * from "./job.vue?vue&type=script&lang=js"
import style0 from "./job.vue?vue&type=style&index=0&id=183852ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183852ac",
  null
  
)

export default component.exports